/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Credits_Tab_GrantInputs */

const en_settings_credits_tab_grant = /** @type {(inputs: Settings_Credits_Tab_GrantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grant`)
};

const zh_settings_credits_tab_grant = /** @type {(inputs: Settings_Credits_Tab_GrantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`获得`)
};

/**
* | output |
* | --- |
* | "Grant" |
*
* @param {Settings_Credits_Tab_GrantInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_credits_tab_grant = /** @type {((inputs?: Settings_Credits_Tab_GrantInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Credits_Tab_GrantInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_credits_tab_grant(inputs)
	return zh_settings_credits_tab_grant(inputs)
});
export { settings_credits_tab_grant as "settings.credits.tab_grant" }